import React from 'react';
import type { RichBlock } from '../../ai/supportAssistantTypes';
import './SupportChatRichContent.css';

type Props = {
  blocks: RichBlock[];
};

const SupportChatRichContent: React.FC<Props> = ({ blocks }) => {
  if (!blocks.length) return null;

  return (
    <div className="soc-ai-rich">
      {blocks.map((block, i) => {
        if (block.kind === 'hero') {
          return (
            <div key={i} className={`soc-ai-rich-hero soc-ai-rich-hero--${block.tone ?? 'default'}`}>
              <div className="soc-ai-rich-hero-icon" aria-hidden>{block.icon}</div>
              <div className="soc-ai-rich-hero-title">{block.title}</div>
              {block.subtitle ? <div className="soc-ai-rich-hero-sub">{block.subtitle}</div> : null}
            </div>
          );
        }
        if (block.kind === 'section') {
          return (
            <div key={i} className="soc-ai-rich-section">
              {block.title}
            </div>
          );
        }
        if (block.kind === 'check') {
          return (
            <ul key={i} className="soc-ai-rich-checks">
              {block.items.map((item) => (
                <li key={item}>✔ {item}</li>
              ))}
            </ul>
          );
        }
        if (block.kind === 'kv') {
          return (
            <div key={i} className="soc-ai-rich-kv">
              {block.rows.map((row) => (
                <div key={`${row.label}-${row.value}`} className={`soc-ai-rich-kv-row ${row.highlight ? 'soc-ai-rich-kv-row--hi' : ''}`}>
                  <span className="soc-ai-rich-kv-label">{row.label}</span>
                  <span className="soc-ai-rich-kv-value">{row.value}</span>
                </div>
              ))}
            </div>
          );
        }
        if (block.kind === 'price') {
          return (
            <div key={i} className="soc-ai-rich-price">
              <div className="soc-ai-rich-price-label">{block.label}</div>
              <div className="soc-ai-rich-price-value">{block.value}</div>
              {block.sub ? <div className="soc-ai-rich-price-sub">{block.sub}</div> : null}
            </div>
          );
        }
        if (block.kind === 'timeline') {
          return (
            <div key={i} className="soc-ai-rich-timeline">
              {block.steps.map((step) => (
                <div key={step.label} className={`soc-ai-rich-step soc-ai-rich-step--${step.status}`}>
                  <span className="soc-ai-rich-step-dot" aria-hidden />
                  <span>{step.label}</span>
                </div>
              ))}
            </div>
          );
        }
        if (block.kind === 'alert') {
          return (
            <div key={i} className={`soc-ai-rich-alert soc-ai-rich-alert--${block.tone}`} role="status">
              {block.text}
            </div>
          );
        }
        if (block.kind === 'progress') {
          return (
            <div key={i} className="soc-ai-rich-progress">
              {block.label ? <div className="soc-ai-rich-progress-label">{block.label}</div> : null}
              <div className="soc-ai-rich-progress-track">
                <div className="soc-ai-rich-progress-bar" style={{ width: `${Math.min(100, Math.max(0, block.percent))}%` }} />
              </div>
            </div>
          );
        }
        if (block.kind === 'map') {
          return (
            <div key={i} className="soc-ai-rich-map" role="img" aria-label={block.label}>
              {block.label}
            </div>
          );
        }
        if (block.kind === 'offer') {
          return (
            <div key={i} className="soc-ai-rich-offer">
              <div className="soc-ai-rich-offer-code">{block.code}</div>
              <div className="soc-ai-rich-offer-desc">{block.description}</div>
            </div>
          );
        }
        if (block.kind === 'otp') {
          return (
            <div key={i} className="soc-ai-rich-otp">
              <div className="soc-ai-rich-otp-code">{block.code}</div>
              <div className="soc-ai-rich-otp-status">{block.status}</div>
            </div>
          );
        }
        if (block.kind === 'rating') {
          return (
            <div key={i} className="soc-ai-rich-rating">
              {block.label ? <span className="soc-ai-rich-rating-label">{block.label}</span> : null}
              <span className="soc-ai-rich-rating-stars">{block.value}</span>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default SupportChatRichContent;
